import { Dialog } from '@mui/material'
import React from 'react'
import SmallButton from '../buttons/SmallButton';
import { useTranslation } from 'react-i18next';

type Props = {
    children?: React.ReactNode;
    open: boolean;
    onClose: () => void;
    texts?: {
        title?: string;
        confirm?: string;
        cancel?: string;
    },
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmationDialog = ({ children, open, onClose, texts, onConfirm, onCancel }: Props) => {
    const { t } = useTranslation();

    return (
        <div>
            <Dialog open={open} onClose={onClose} PaperProps={{ sx: { borderRadius: "12px" } }}>
                <div className="bg-primary pt-2 min-w-[300px] md:max-w-[400] max-w-[600]">
                    <div className="bg-white rounded-[10px]">
                        {texts && texts.title && (
                            <div className="px-3 pt-2 font-bold text-[20px] text-center">
                                {texts.title}
                            </div>
                        )}
                        <div className="px-3 py-2">
                            {children}
                        </div>
                        <div className="flex justify-end gap-2 px-2 pb-3">
                            <SmallButton
                                variant="strike"
                                onClick={onConfirm}
                                fullWidthOnMobile
                            >
                                {texts && texts.confirm ? texts.confirm : t('common.confirm')}
                            </SmallButton>
                            <SmallButton
                                variant="outlined"
                                onClick={onCancel}
                                fullWidthOnMobile
                            >
                                {texts && texts.cancel ? texts.cancel : t('common.cancel')}
                            </SmallButton>
                        </div>
                    </div>

                </div>
            </Dialog>
        </div>
    )
}

export default ConfirmationDialog